'use client';
import { startTransition, useCallback } from 'react';
import {
  Link,
  useLinkClickHandler,
  useNavigate,
  type LinkProps,
  type NavigateOptions,
  type To,
} from 'react-router';

export function useTransitionNavigate() {
  const navigate = useNavigate();
  return useCallback(
    (to: To | number, options?: NavigateOptions) => {
      startTransition(() => {
        if (typeof to === 'number') navigate(to);
        else navigate(to, options);
      });
    },
    [navigate],
  );
}

export default function TransitionLink(props: LinkProps) {
  const handleClick = useLinkClickHandler(props.to, {
    ...(props.target === undefined ? {} : { target: props.target }),
    ...(props.replace === undefined ? {} : { replace: props.replace }),
    ...(props.state === undefined ? {} : { state: props.state }),
    ...(props.preventScrollReset === undefined
      ? {}
      : { preventScrollReset: props.preventScrollReset }),
    ...(props.relative === undefined ? {} : { relative: props.relative }),
  });

  return (
    <Link
      {...props}
      onClick={(event) => {
        props.onClick?.(event);
        if (event.defaultPrevented) return;
        startTransition(() => {
          handleClick(event);
        });
      }}
    />
  );
}
